import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { TeiHubLinkQrDataParam } from "features/hublink/core/tei-hub-link.param";
import {
  GetTeiHubLinkSaveQrDataRepository,
  GetTeiHubLinkSaveQrDataResponse,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkSaveQrData {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkSaveQrData;
  message: string;
}

const initialState: InitialState = {
  status: TeiHubLinkSaveQrData.initial,
  message: "",
};

export const teiHubLinkSaveQrData = createAsyncThunk(
  "teiHubLinkSaveQrData",
  async (param: TeiHubLinkQrDataParam, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkSaveQrDataResponse =
        await GetTeiHubLinkSaveQrDataRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkSaveQrDataSlice = createSlice({
  name: "teiHubLinkSaveQrData",
  initialState,
  reducers: {
    resetTeiHubLinkSaveQrData: (state) => {
      state.status = TeiHubLinkSaveQrData.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkSaveQrData.pending, (state) => {
        state.status = TeiHubLinkSaveQrData.inProgress;
      })
      .addCase(teiHubLinkSaveQrData.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = TeiHubLinkSaveQrData.success;
          state.message = message;
        }
      })
      .addCase(teiHubLinkSaveQrData.rejected, (state, action) => {
        state.status = TeiHubLinkSaveQrData.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectTeiHubLinkSaveQrData = (state: RootState) =>
  state.teiHubLinkSaveQrData;

export const { resetTeiHubLinkSaveQrData } = teiHubLinkSaveQrDataSlice.actions;
export default teiHubLinkSaveQrDataSlice.reducer;
